import Api from '../../../helpers/Api';

// ACTION TYPES

export const SET_AOVIVO_NEWS = 'SET_AOVIVO_NEWS';
const setAovivoNews = (data) => ({
    type: SET_AOVIVO_NEWS,
    data,
});


// ACTIONS

export const fetchAovivoNewsIfNeeded = (limit = 12) => (dispatch, getState) => {
    const newsData = getState().aovivo.aovivoNews.newsData;

    if (newsData.length === 0) {
        const category = 'musica';
        const query = `/api/v1/news/getNews/0/${limit}/false/false/${category}`;

        return Api.progressGet(dispatch, query).then((json) => {
            if (json.status === 'success') {
                return dispatch(setAovivoNews(json.data));
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            // eslint-disable-next-line no-console
            console.log('aovivo - fetchAovivoNewsIfNeeded got error: ', error);
        });
    }

    return Promise.resolve(1);
};
